/// Rules for units that differ between LAN adapters and other units.
/// A product range can allow a LAN adapter without a model (material code),
/// see docs/tickets/DM-4591-lan-adapter-without-model.md.

export const isLanAdapter = (unit) => unit?.type === 'lan_adapter'

/// Returns `false` only when a known product range explicitly allows a LAN adapter without a model.
/// An unknown product range requires the model. SBM also sends the flag as `false`
/// on an empty product range object (no `id`), so the flag alone is not enough.
export const isLanModelRequired = (productRange) =>
  !productRange?.id ||
  productRange.product_name_required_for_lan_adapter !== false

/// Returns the MAC address or serial number that identifies a LAN adapter.
export const getLanAdapterAddress = (unit) =>
  unit?.mac_address || unit?.macAddress || unit?.serial || null

/// Removes separators and casing, so `AA:BB-cc` and `aabbcc` compare equal.
export const normaliseAddress = (value) =>
  value
    ? String(value)
        .replace(/[^0-9a-z]/gi, '')
        .toLowerCase()
    : ''

/// Returns `true` when the unit has the data SBM needs to register it.
export const isUnitComplete = (unit, productRange) => {
  if (!unit) return false
  if (isLanAdapter(unit)) {
    return (
      !!getLanAdapterAddress(unit) &&
      (!!unit.material || !isLanModelRequired(productRange))
    )
  }
  return !!unit.material && !!unit.serial
}

/// Returns `true` when both objects describe the same physical unit.
/// LAN adapters are matched on their address, because the model can be empty.
export const isSameUnit = (a, b) => {
  if (!a || !b) return false
  if (isLanAdapter(a) || isLanAdapter(b)) {
    const addressA = normaliseAddress(getLanAdapterAddress(a))
    const addressB = normaliseAddress(getLanAdapterAddress(b))
    if (addressA && addressB) {
      return addressA === addressB
    }
  }
  return a.material === b.material && a.serial === b.serial
}
